import React, { useEffect } from "react";
import SmoothScroll from "./scroll/SmoothScroll";
import TechLayout from "./TechLayout";
import HeroSection from "./sections/HeroSection";
import CapabilitiesSection from "./sections/CapabilitiesSection";
import ProcessSection from "./sections/ProcessSection";
import DomainsSection from "./sections/DomainsSection";
import CTASection from "./sections/CTASection";
import useTechCopy from "./useTechCopy";

// Architecture:
//   HeroSection    — h-screen looping video with the headline over it
//   Other sections — solid black, stacked below the hero

export default function OnHumanTechPage() {
  const copy = useTechCopy();

  useEffect(() => {
    const prev = document.title;
    document.title = copy.meta.title;
    return () => {
      document.title = prev;
    };
  }, [copy]);

  return (
    <SmoothScroll>
      <TechLayout>
        <HeroSection />
        <CapabilitiesSection />
        <ProcessSection />
        <DomainsSection />
        <CTASection />
      </TechLayout>
    </SmoothScroll>
  );
}
